import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Table, TableHead, TableBody, TableRow, TableCell,
  Button, CircularProgress, Typography, Box, Grid
} from '@mui/material';
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";

const PedidoExpressDetalleModal = ({ open, onClose, idPedido }) => {
  const [productos, setProductos] = useState([]);
  const [pedido, setPedido] = useState(null);
  const [loading, setLoading] = useState(false);
  const printRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef: printRef
  });
  useEffect(() => {
    if (!open || !idPedido) return;

    setLoading(true);
    fetch(`https://bibliotecadlago.com/php/pedidoexpress_detalle.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ IdPedido: idPedido })
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setPedido(data.pedido);
          setProductos(data.productos);
        } else {
          setPedido(null);
          setProductos([]);
        }
      })
      .catch(() => {
        setPedido(null);
        setProductos([]);
      })
      .finally(() => setLoading(false));
  }, [open, idPedido]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth ref={printRef} >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          textAlign: "center",
        }}
      >
        <img
          src="\logo llantas.png"
          alt="logo izquierdo"
          style={{ height: 40 }}
        />
        <Box sx={{ flex: 1 }}>
          <strong>
            Detalle del Pedido Express #{idPedido}
            <br />
            {pedido ? pedido.ClaEnlaceMichelin : ""}
          </strong>
        </Box>
        <img
          src="\ENTREGAEXPRESS.jpeg"
          alt="logo derecho"
          style={{ height: 40 }}
        />
      </DialogTitle>
      <DialogContent dividers >
        {loading ? (
          <Box display="flex" justifyContent="center" p={3}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            {pedido ? (
              <>
                <Box mb={3} display="flex" justifyContent="flex-start">
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} sx={{ marginRight: 8 }}>
                      <Typography><strong>Fecha:</strong> {pedido.Fecha}</Typography>
                      <Typography><strong>Cliente:</strong> {pedido.Nombre}</Typography>
                      <Typography><strong>Asesor:</strong> {pedido.Asesor}</Typography>
                      <Typography><strong>Ultimo cambio de estatus:</strong> {pedido.FechaCambio}</Typography>
                      {pedido.Encargado && (
                        <Typography>
                          <strong>Encargado:</strong> {pedido.Encargado}
                        </Typography>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography><strong>Seguimiento:</strong> {pedido.Seguimiento}</Typography>
                      <Typography><strong>Facturación:</strong> {pedido.Facturacion}</Typography>
                      <Typography><strong>Estatus:</strong> {pedido.Estatus}</Typography>
                      <Typography><strong>Realizado por:</strong> {pedido.NombreCambio}</Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Grid item xs={12}>
                  <Typography><strong>Direccion a Entregar:</strong> {pedido.DireccionEntregar}</Typography>
                  <Typography><strong>Comentario:</strong> {pedido.Comentario}</Typography>
                </Grid>
              </>



            ) : (
              <Typography color="error">No se pudo cargar la información del pedido.</Typography>
            )}

            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center">MSPN</TableCell>
                  <TableCell align="center">Descripción</TableCell>
                  <TableCell align="center">Cantidad</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {productos.map((item) => (
                  <TableRow key={item.MSPN}>
                    <TableCell align="center">{item.MSPN}</TableCell>
                    <TableCell align="center">{item.descripcion}</TableCell>
                    <TableCell align="center">{item.Cantidad}</TableCell>
                  </TableRow>
                ))}
                {pedido ? (
                  <TableRow>
                    <TableCell colSpan={2} align="center">
                      <strong>Total de Cantidad</strong>
                    </TableCell>
                    <TableCell align="center">
                      <strong>{pedido.Total}</strong>
                    </TableCell>
                  </TableRow>
                ) : (
                  <Typography color="error">No se pudo cargar la información del pedido.</Typography>
                )}
                {productos.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={3} align="center">No hay productos en este pedido.</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handlePrint}
          >
            Imprimir
          </Button>

          <Button
            variant="contained"
            color="error"
            size="small"
            onClick={onClose}
          >
            Cerrar
          </Button>
        </DialogActions>
      </DialogActions>
    </Dialog>
  );
};

export default PedidoExpressDetalleModal;
